import { useState } from 'react'
import { ReactComponent as SvgCopy } from '../../images/svg/icon-copy.svg'
import { ReactComponent as SvgMark } from '../../images/svg/mark.svg'
import styles from './styles.module.css'

const CopyText = props => {
  const { text } = props
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    if (navigator.clipboard) {
      setCopied(true)
      navigator.clipboard.writeText(text)
      setTimeout(() => {
        setCopied(false)
      }, 500)
    } else {
      console.warn('Your browser is not support navigator.clipboard')
    }
  }

  const icon = copied
    ? <SvgMark className={styles.icon} />
    : <SvgCopy className={styles.icon} onClick={handleCopy} />

  return (
    <>
      {props.children} {icon}
    </>
  )
}

export default CopyText
